module.exports = __webpack_public_path__ + "img/app-indicator.d9ed682c.svg";